import { useEffect } from 'react';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

import { Conversations } from '../types';
import { useMessagingClient } from './useMessagingClient';

export function useUnreadConversations(): {
    unreadConversations: Conversations;
} {
    const messagingClient = useMessagingClient();

    // EXTERNAL STATE

    const userUuid: ReturnType<typeof messagingClient.selectors.getActiveUserUuid> =
        useSyncExternalStoreWithSelector(
            messagingClient.subscribe,
            messagingClient.getState,
            undefined,
            messagingClient.selectors.getActiveUserUuid,
        );

    const unreadConversations: ReturnType<typeof messagingClient.selectors.getUnreadConversations> =
        useSyncExternalStoreWithSelector(
            messagingClient.subscribe,
            messagingClient.getState,
            undefined,
            messagingClient.selectors.getUnreadConversations,
        );

    // LIFECYCLE

    useEffect(() => {
        messagingClient.getConversations().catch(() => {});
    }, [messagingClient, userUuid]);

    return {
        unreadConversations,
    };
}
